<template>
<v-dialog
    v-model="shown"
    max-width="967"
    @click:outside="cancel"
  >
  <div v-if="asyncDataStatus_ready" class="col-full push-top popup">
    <h2>
      Uredite artikel:
    </h2>

    <ArticleForm
      ref="articleformedit"
      @sprememba="spremeni"
      @save="save"
      @cancel="cancel"
      :groups="groups"
      :skrij="true"
      :categories="categories"
      :article="article"
      :articles="articles"
    />

    <v-row justify="space-between">
      <v-col cols="auto">
        <h2>
          Sestavnica
        </h2>
      </v-col>
      <v-col cols="auto" style="display: flex; align-items: center; justify-content: space-between;">
        <v-col style="align-self: center">
          <h4>
            Sestavnica artikla:
          </h4>
        </v-col>
        <v-col cols="auto" style="padding: 0; display: flex; border-bottom: 1px solid #000;">
          <select class="selectList">
            <option v-for="article in localMembership" :key="article.id">{{article.article_name}}
            </option>
          </select>
          <div class="v-input__append-inner">
            <div class="v-input__icon v-input__icon--append">
              <i aria-hidden="true" class="v-icon notranslate mdi mdi-menu-down theme--light"></i>
            </div>
          </div>
        </v-col>
      </v-col>
      <v-col cols="auto" style="display: flex;">
        <v-col style="align-self: center">
          <h4>
            Velja od:
          </h4>
        </v-col>
        <v-col cols="auto">
          <DateSelector
            :date="startDate"
            @change="updateStartDateTime"
          />
        </v-col>
      </v-col>
      <v-col cols="auto" style="display: flex;">
        <v-col cols="auto">
          <v-btn icon small @click="showCompositionHistory">
            <v-icon>
              fas fa-exclamation-circle
            </v-icon>
          </v-btn>
        </v-col>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Naziv artikla
                </th>
                <th class="text-left">
                  Količina
                </th>
                <th class="text-left">
                  Merska enota
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <component
                v-for="(article, index) in localArticles"
                :key="article.article"
                :is="articleToEdit === index ? 'ArticleCompositionInput' : 'ArticleCompositionItem'"
                :article="article"
                @edit="editArticle(index)"
                @delete="deleteArticle(index)"
                :articles="articlesInventoryKept"
                @cancel="articleToEdit = null"
                @update="updateArticleRowInLocalArray(index, $event)"
              >
              </component>
              <ArticleCompositionInput
                v-if="addingArticle"
                :articles="articlesInventoryKept"
                @cancel="addingArticle = false"
                @save="addArticleRowToLocalArray"
              />
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row class="my-4">
      <v-btn
        color="#0F998E"
        class="white--text ml-3"
        @click="addingArticle = true; nastaviZacetniDatum;"
        :disabled="addingArticle"
      >
        Dodaj postavko
        <v-icon right dark>mdi-plus</v-icon>
      </v-btn>
    </v-row>
    <v-row>
      <v-btn
        color="#0F998E"
        class="white--text ml-3"
        :disabled="false"
        @click="undoChanges"
      >
        Prekliči
      </v-btn>
      <v-btn
        color="#0F998E"
        class="white--text ml-3"
        @click="doSaveArticleComposition"
      >
        Shrani
      </v-btn>
    </v-row>
    <v-row>
      <v-col class="mt-12"></v-col>
    </v-row>
    <div ref="bottomOfThePage" style="height: 50px;"></div>
  </div>
</v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import ArticleForm from '@/components/ArticleForm'
import ArticleCompositionItem from '@/components/ArticleCompositionItem'
import ArticleCompositionInput from '@/components/ArticleCompositionInput'
import DateSelector from '@/components/DateSelector'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'
import moment from 'moment'

export default {
  components: {
    ArticleForm,
    ArticleCompositionItem,
    ArticleCompositionInput,
    DateSelector
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      oldArticleValues: null,
      localArticles: [],
      localMembership: [],
      unsavedChanges: false,
      showAddArticleModal: false,
      addingArticle: false,
      articleToEdit: null,
      startDate: '',
      startTime: '00:00',
      shown: false
    }
  },
  computed: {
    article () {
      return this.$store.state.articles.items[this.id]
    },
    groups () {
      return objectToArray(this.$store.state.groups.items)
    },
    categories () {
      return objectToArray(this.$store.state.categories.lastLevelItems)
    },
    articles () {
      return objectToArray(this.$store.state.articles.items)
    },
    articlesInventoryKept () {
      return this.articles.filter(article => article.inventory_kept)
    }
  },
  methods: {
    ...mapActions('articles', { loadItem: 'loadItem', saveItem: 'saveItem', loadArticles: 'loadItems' }),
    ...mapActions('groups', { loadGroups: 'loadItems' }),
    ...mapActions('categories', { loadCategories: 'loadLastLevelItems' }),
    ...mapActions('articleComposition', { loadArticleCompositionMembership: 'loadArticleCompositionMembership', loadArticleComposition: 'loadItems', saveArticleComposition: 'saveItems', getHistory: 'loadArticleCompositionHistory' }),
    showCompositionHistory () {
      this.getHistory(this.id)
    },
    nastaviZacetniDatum () {
      this.startDate = this.startDate === null ? moment().format('YYYY-MM-DD') : this.startDate
    },
    updateStartDateTime ({ date }) {
      this.startDate = date
      this.spremeni()
    },
    spremeni () {
      this.unsavedChanges = !this.unsavedChanges
    },
    // sejvamo artikel
    save ({ data }) {
      if (this.articleCategoryWasChanged(data)) {
        data.sort_order = null
      }
      saveItem(data, 'MyCompanyArticles', this)
      setTimeout(() => {
        this.cancel(data)
      }, 500)
    },
    cancel (data) {
      // this.$router.push({ name: 'MyCompanyArticles' })
      this.shown = false
      this.$emit('zapri', data)
    },
    articleCategoryWasChanged (data) {
      return this.oldArticleValues.category !== data.category
    },
    // to shrani samo sestavnico od artikla!
    doSaveArticleComposition () {
      if (this.startDate) {
        this.localArticles.map((article) => {
          article.start_date = `${this.startDate}T${this.startTime}`
        })
      }
      this.saveArticleComposition({
        articleId: this.id,
        items: {
          articles: this.localArticles
        }
      })
        .then(response => {
          this.unsavedChanges = false
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          this.$refs.articleformedit.save()
        })
    },
    updateArticleRowInLocalArray (index, article) {
      this.articleToEdit = null
      this.localArticles[index] = article
      this.unsavedChanges = true
    },
    addArticleRowToLocalArray (article) {
      this.addingArticle = false
      this.localArticles.push(article)
      this.unsavedChanges = true
      this.$nextTick(() => {
        this.addingArticle = true
      })
      this.$refs.bottomOfThePage.scrollIntoView()
    },
    editArticle (index) {
      this.articleToEdit = index
    },
    deleteArticle (index) {
      this.unsavedChanges = true
      return this.localArticles.splice(index, 1)
    },
    undoChanges () {
      this.loadArticleComposition(this.id)
        .then(response => {
          this.localArticles = response
          this.unsavedChanges = false
          this.addingArticle = false
          this.cancel()
        })
    }
  },
  created () {
    this.shown = false
    Promise.all([
      this.loadGroups(),
      this.loadCategories(),
      this.loadArticles(),
      this.loadArticleComposition(this.id),
      this.loadArticleCompositionMembership(this.id)
    ])
      .then(items => {
        this.asyncDataStatus_fetched()
        this.oldArticleValues = this.article
        this.localArticles = items[3]
        this.localMembership = items[4]
        // console.log(this.localMembership.map(e => e.article_name))
        const dttm = items[3].length > 0 ? items[3][0].start_date.split('T') : null
        this.startDate = dttm && dttm[0] ? dttm[0] : ''
        this.shown = true
      })
  }
}
</script>

<style lang="scss" scoped>
.popup {
  background-color: #fff;
  padding: 1rem;
  // max-height: calc(90vh - 130px);
  /* overflow: auto; */
}
.selectList {
  display: flex;
  outline: none;
}
</style>
